import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=49c7313a&scoped=true&"
import script from "./BaseDialog.vue?vue&type=script&lang=js&"
export * from "./BaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=49c7313a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7313a",
  null
  
)

export default component.exports